import { Workspace } from "@/domain/workspace/models/workspace-model";

import { IndicatorCreatedAtColumn } from "./columns/indicator-created-at-column";
import { IndicatorDescriptionColumn } from "./columns/indicator-description-column";
import { IndicatorLatestValueColumn } from "./columns/indicator-latest-value-column";
import { IndicatorTitleColumn } from "./columns/indicator-title-column";
import { IndicatorTypeColumn } from "./columns/indicator-type-column";
import { IndicatorUnitColumn } from "./columns/indicator-unit-column";
import { IndicatorUpdatedAtColumn } from "./columns/indicator-updated-at-columns";
import { IndicatorValueCountColumn } from "./columns/indicator-value-count-column";

interface UseIndicatorDatatableColumnsProps {
  workspace: Workspace;
  editable?: boolean;
}

export const useIndicatorDatatableColumns = ({ workspace, editable = false }: UseIndicatorDatatableColumnsProps) => {
  const indicatorTitleColumn = IndicatorTitleColumn({
    workspace: workspace,
  });
  const indicatorDescriptionColumn = IndicatorDescriptionColumn({
    workspace: workspace,
  });
  const indicatorUnitColumn = IndicatorUnitColumn({
    workspace: workspace,
    editable: editable,
  });
  const indicatorTypeColumn = IndicatorTypeColumn({
    workspace: workspace,
    editable: editable,
  });
  const indicatorLatestValueColumn = IndicatorLatestValueColumn({
    workspace: workspace,
  });
  const indicatorValueCountColumn = IndicatorValueCountColumn({
    workspace: workspace,
  });
  const indicatorUpdatedAtColumn = IndicatorUpdatedAtColumn();
  const indicatorCreatedAtColumn = IndicatorCreatedAtColumn();

  return {
    columnConfigurationList: [
      indicatorTitleColumn,
      indicatorDescriptionColumn,
      indicatorUnitColumn,
      indicatorTypeColumn,
      indicatorValueCountColumn,
      indicatorLatestValueColumn,
      indicatorUpdatedAtColumn,
      indicatorCreatedAtColumn,
    ],
  };
};
